import { cn } from '@/lib/utils';
import { initialsOf } from '@/platform/features/profile/profile-shared';

type UserAvatarProps = {
  firstName: string;
  lastName: string;
  displayName: string;
  profilePhotoUrl?: string | null;
  className?: string;
  imageClassName?: string;
};

export function UserAvatar({
  firstName,
  lastName,
  displayName,
  profilePhotoUrl,
  className,
  imageClassName,
}: UserAvatarProps) {
  const initials = initialsOf(firstName, lastName, displayName);

  if (profilePhotoUrl) {
    return (
      <img
        src={profilePhotoUrl}
        alt=""
        className={cn('size-full rounded-full object-cover', imageClassName, className)}
      />
    );
  }

  return (
    <span
      className={cn(
        'flex size-full items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground',
        className,
      )}
      aria-hidden
    >
      {initials}
    </span>
  );
}
